import React from "react";
import { Container, Row } from "reactstrap";

const WHATSAPP_AGENDA_URL = "https://wa.me/573197683063?text=Estoy%20interesado%20en%20los%20servicios%20de%20Avanza%20Empleo";

const Cta = () => {
  return (
    <React.Fragment>
      <section className="section section-lg bg-light py-lg-5">
        <Container>
          <Row className="justify-content-center">
            <div className="section-title text-center px-2">
              <h3 className="title mb-3 pb-2">
                ¿Necesitas asesoría en Gestión Humana?
              </h3>
              <p className="para-desc text-muted mx-auto mb-4" style={{ maxWidth: "420px" }}>
                Asesoría rápida, directa y personalizada por WhatsApp.
              </p>
              <div className="mt-4">
                <a
                  href={WHATSAPP_AGENDA_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-hover mt-2"
                >
                  <i className="uil uil-whatsapp me-1"></i> Agenda tu cita por WhatsApp
                </a>
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Cta;
